<!-- Content -->
<div class="border-bottom-1 border-300 p-3" [formGroup]="formGroup">
    <!-- Button Set -->
    <label class="block font-medium text-700 text-xs mb-2 uppercase">{{ 'SEND_EMAIL.WHAT_TIME' | translate : {type:type} }}</label>
    <div class="p-buttonset white-space-nowrap mb-3" *ngIf="!showDefaultMessage">
        <button
            *ngFor="let option of sendMessageOptions"
            pButton
            pRipple
            type="button"
            [ngClass]="{ 'bg-primary': selectedSendMessageOption === option, 'surface-600': selectedSendMessageOption !== option }"
            (click)="selectSendMessageOption(option)"
            [disabled]="automationMaster.value && !checkHaveSameDayOrImmediate(option)"
            class="border-right-1 border-white text-sm md:px-5"
            [label]="option === 'After' ? 'After Event' : option === 'Before' ? 'Before Event' : 'On Event'"
        ></button>
    </div>
    <!-- Button Set -->

    <div *ngIf="showDefaultMessage" >
        <p-message severity="info" icon="fa fa-info-circle" aria-label="default-message">
            System Default
        </p-message>
    </div>

    <!-- Message After -->
    <div *ngIf="!showDefaultMessage">
        <label class="block font-medium text-700 text-xs mb-2 uppercase">{{ 'SEND_EMAIL.CHOOSE' | translate }}</label>
        <div class="md:w-9">
            <div class="grid">
                <div class="col-4">
                    <p-select
                        [options]="automationScheduleTypes"
                        formControlName="automation_schedule_type"
                        styleClass="text-sm text-black-alpha-90 w-full"
                        optionLabel="key"
                        filterBy="key"
                        placeholder="{{'common.PLACEHOLDER.SELECT' | translate}}"
                        [ngClass]="{ 'ng-invalid ng-dirty': SelectedAutomationScheduleTypeFormControl.invalid && SelectedAutomationScheduleTypeFormControl.touched }"
                    >
                        <ng-template pTemplate="selectedItem">
                            <div *ngIf="SelectedAutomationScheduleTypeFormControl.value" class="text-sm">{{SelectedAutomationScheduleTypeFormControl.value.key}}</div>
                        </ng-template>
                        <ng-template let-type pTemplate="item">
                            <div class="text-sm">{{type.key}}</div>
                        </ng-template>
                    </p-select>
                </div>
                <div class="col-8">
                    <p-select
                        [options]="automationTimingOptions"
                        formControlName="automation_timing"
                        optionLabel="key"
                        filterBy="key"
                        styleClass="text-sm text-black-alpha-90 w-full"
                        placeholder="{{'common.PLACEHOLDER.SELECT' | translate}}"
                        [ngClass]="{ 'ng-invalid ng-dirty': SelectedAutomationTimingFormControl.invalid && SelectedAutomationTimingFormControl.touched }"
                    >
                        <ng-template pTemplate="selectedItem">
                            <div *ngIf="SelectedAutomationTimingFormControl.value" class="text-sm">{{SelectedAutomationTimingFormControl.value.key}}</div>
                        </ng-template>
                        <ng-template let-day pTemplate="item">
                            <div class="text-sm">{{day.key}}</div>
                        </ng-template>
                    </p-select>
                </div>
            </div>
        </div>
    </div>
    <!-- Message After -->
    <div class="" *ngIf="SelectedAutomationTimingTypeFormControl.value === 'Immediate'">
        <p-message severity="error" icon="fa fa-info-circle" aria-label="immediate-message">
            {{ 'SEND_EMAIL.ON_IMMIDIATE' | translate }}
        </p-message>
    </div>
</div>
<!-- Content -->
